import axiosClient from '../configs/axios.js';

class EmptyCylindercolllectionList {
  
    async EmptyCylinderList(params) {
        try {
            const response = await axiosClient.get(
`/emptycylinderColletion/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}${params.depot_id ? `&&depot_id=${params.depot_id}` : ''}`
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching cylinder list:', error);
            throw error;
        }
    }
  
      async addEmptyCylinder(data) {
            try {
                const response = await axiosClient.post('/emptycylinderColletion/add', data, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        // Add Authorization header if needed
                        // 'Authorization': `Bearer ${token}`,
                    },
                });
                return response.data;
            } catch (error) {
                console.error('Error adding cylinder:', error);
                throw error;
            }
        }
async checkCylExists(cyl_no, tag_no) {
  try {
    const response = await axiosClient.get(
      `/emptycylinderColletion/checkCylExists?cyl_no=${encodeURIComponent(cyl_no || '')}&tag_no=${encodeURIComponent(tag_no || '')}`
    );
    return response.data;
  } catch (error) {
    return { exists: false };
  }
}
    

async editDeleteEmptyCollection(data) {
        try {
            const response = await axiosClient.put(`/emptycylinderColletion/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

async addNewCylinder(data) {
  try {
    const response = await axiosClient.post('/emptycylinderColletion/addCyl', data);
    return response.data;
  } catch (error) {
    // ✅ backend ka message properly throw karo
    throw new Error(error.response?.data?.message || error.message);
  }
}
    
    async getCustomerCylinder(custId) {
  try {
    const response = await axiosClient.get(
     `/emptycylinderColletion/customercylinder/${custId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching customer cylinders:", error);
    throw error;
  }
}
}
export default new EmptyCylindercolllectionList();